import { render, staticRenderFns } from "./HomeTxViewBox.vue?vue&type=template&id=85761754&scoped=true&"
import script from "./HomeTxViewBox.vue?vue&type=script&lang=js&"
export * from "./HomeTxViewBox.vue?vue&type=script&lang=js&"
import style0 from "./HomeTxViewBox.vue?vue&type=style&index=0&id=85761754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85761754",
  null
  
)

export default component.exports